/**
 * A shortcut for packing structs.
 */
export const packed = { isPacked: true };
/**
 * A shortcut for setting alignment
 */
export function align(n) {
    return { alignment: n };
}
